// Regroupe des méthodes utilisables partout.
// Le nom de la fonction doit commencer par IsisFct
//  afin de ne pas entrer en conflit avec d'autres programmations

export default {
  methods: {
    IsisFct_Date2String(T_Date) {
      var D_Date = new Date(T_Date);
      var L_Day = parseInt(D_Date.getDate());
      var T_Day = L_Day.toString();
      if (L_Day < 10) {
        T_Day = "0" + T_Day;
      }

      var L_Month = parseInt(D_Date.getMonth()) + 1;
      var T_Month = L_Month.toString();
      if (L_Month < 10) {
        T_Month = "0" + T_Month;
      }

      var T_Year = D_Date.getFullYear().toString();

      return T_Year + "-" + T_Month + "-" + T_Day;
    },
    IsisFct_Date2Display(T_Date) {
      var date2Display = "";
      if (T_Date != null) {
        date2Display = T_Date.substr(8, 2) + "/" + T_Date.substr(5, 2) + "/" + T_Date.substr(0, 4);
      }
      return date2Display;
    },
    IsisFct_Date2SQL(T_Date) {
      return T_Date.substr(6, 4) + "-" + T_Date.substr(3, 2) + "-" + T_Date.substr(0, 2);
    },
    IsisFct_DateCheck(T_Date) {
      var B_Valid = false;

      var B_ContainsDash = T_Date.indexOf("-") >= 0;
      var B_ContainsSlash = T_Date.indexOf("/") >= 0;

      var T_Day = "";
      var T_Month = "";
      var T_Year = "";

      var TT_Split = [];
      if (B_ContainsDash) {
        TT_Split = T_Date.split("-");
      } else if (B_ContainsSlash) {
        TT_Split = T_Date.split("/");
      } else if (T_Date.length == 8) {
        // Format 20190124
        TT_Split[0] = T_Date.substr(6, 2);
        TT_Split[1] = T_Date.substr(4, 2);
        TT_Split[2] = T_Date.substr(0, 4);
      }

      if (TT_Split.length == 3) {
        if (parseInt(TT_Split[0]) > 1000) {
          // Année -/ Mois -/ Jour
          T_Day = TT_Split[2];
          T_Month = TT_Split[1];
          T_Year = TT_Split[0];
        } // Jour -/ Mois -/ Année
        else {
          T_Day = TT_Split[0];
          T_Month = TT_Split[1];
          T_Year = TT_Split[2];
        }
      }

      if (T_Day != "") {
        if (parseInt(T_Day) > 31) {
          B_Valid = false;
        } else if (parseInt(T_Month) > 12) {
          B_Valid = false;
        } else if (parseInt(T_Year) < 1900 || parseInt(T_Year) > 2900) {
          B_Valid = false;
        } else {
          B_Valid = true;
        }

        if (B_Valid) {
          if (parseInt(T_Day) < 10) {
            T_Day = "0" + parseInt(T_Day);
          }
          if (parseInt(T_Month) < 10) {
            T_Month = "0" + parseInt(T_Month);
          }
          return T_Day + "/" + T_Month + "/" + T_Year;
        }
      }

      if (!B_Valid) {
        // On retourne la date du jour
        var D_Date = new Date();
        return this.IsisFct_Date2Display(this.IsisFct_Date2String(D_Date));
      }
    }
  }
};
